import { render, staticRenderFns } from "./BarNavPortfolio.vue?vue&type=template&id=147bf50c&scoped=true&"
import script from "./BarNavPortfolio.vue?vue&type=script&lang=js&"
export * from "./BarNavPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./BarNavPortfolio.vue?vue&type=style&index=0&id=147bf50c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bf50c",
  null
  
)

export default component.exports